var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrigin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10626_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 11.9051C2.62385 12.5857 1.66666 13.5341 1.66666 14.5832C1.66666 16.6542 5.39762 18.3332 9.99999 18.3332C14.6024 18.3332 18.3333 16.6542 18.3333 14.5832C18.3333 13.5341 17.3761 12.5857 15.8333 11.9051M15 6.6665C15 10.0529 11.25 11.6665 9.99999 14.1665C8.74999 11.6665 4.99999 10.0529 4.99999 6.6665C4.99999 3.90508 7.23857 1.6665 9.99999 1.6665C12.7614 1.6665 15 3.90508 15 6.6665ZM10.8333 6.6665C10.8333 7.12674 10.4602 7.49984 9.99999 7.49984C9.53975 7.49984 9.16666 7.12674 9.16666 6.6665C9.16666 6.20627 9.53975 5.83317 9.99999 5.83317C10.4602 5.83317 10.8333 6.20627 10.8333 6.6665Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10626_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigin);
export default __webpack_public_path__ + "static/media/origin.0f5d485ae6e187faec2ff567256974f3.svg";
export { ForwardRef as ReactComponent };